import { req } from 'vuelidate/lib/validators/common'
import { withParams } from 'vuelidate'
import { CNPJ } from 'cpf_cnpj'

export default withParams({ type: 'isCNPJ' }, value => !req(value) || CNPJ.isValid(value))
